import React from 'react';

const cartContext = React.createContext({
    items: [],
    additem: (item) => {},
    removeItem: (id) => {}
});

export default cartContext;